import SelectorGenerico from 'pages/components/SelectorGenerico';
import { successAlert } from 'pages/components/SweetAlert';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardHeader, Form, FormGroup, Input,  Modal } from 'reactstrap';
import { getTipoEgresos } from 'services/EgresosService';
import { warningAlert } from 'pages/components/SweetAlert';
import { postEgreso } from 'services/EgresosService';
import SubirComprobante from './SubirComprobante';
import {ValidarDatoEgreso} from '../../../../validators/validators'


const ModalAggEgreso=(props)=>{

    const {ModalAgregarEgreso, setModalAgregarEgreso, CierreCajaId}=props;
    const [ComprobanteId, setComprobanteId] = useState(null)

    const [Importe, setImporte] = useState("");
    const [Operacion, setOperacion] = useState("");
    const [Egreso, setEgreso] = useState("");
    const [Comentario, setComentario] = useState("");
    const [TiposEgresos, SetTipoEgresos] = useState([]);
    const [alertSweet, setAlert] = useState(null);

    const traerTiposEgresos = async() => {
      let Tegr = await getTipoEgresos();
      if (Tegr !== null && Tegr !== '') {
        SetTipoEgresos(Tegr);
      }
    }

    const AgregarEgreso = async()=>{
    
      let egreso = {importe: parseInt(Importe),numeroOperacion:Operacion,comentario: Comentario,comprobanteId: ComprobanteId,tipoEgresoId: parseInt(Egreso),cierrecajasId: CierreCajaId}
      if(!ValidarDatoEgreso(egreso).ok){
        warningAlert(setAlert,ValidarDatoEgreso(egreso).mensaje)
        return
      }
      
      let result = await postEgreso(egreso)
      if(result != null){
        setImporte("")
        setOperacion("")
        setEgreso("")
        setComentario("")
        successAlert(setAlert, "Egreso Agregado!", "")
        setModalAgregarEgreso(false)
      }else{
        warningAlert(setAlert, 'No se pudo agregar el Egreso')
      }
  }

  

  const cambiarImporte = event => {
    setImporte(event.target.value);
  };
  const cambiarOperacion = event => {
    setOperacion(event.target.value);
  };
  const cambiarComentario = event => {
    setComentario(event.target.value);
  };



  useEffect(() => {
    traerTiposEgresos();
  }, [])

    return(
        <>
        {alertSweet}
        <Modal
                            className="modal-dialog-centered"
                            size="sm"
                            isOpen={ModalAgregarEgreso}
                            toggle={() => setModalAgregarEgreso(false)}
                          >
                          <div className="modal-body p-0">
                            <Card className="bg-secondary shadow border-0">
                              <CardHeader className="bg-transparent pb-5">
                                <div className="text-center"><b>Nuevo Egreso</b>
                                <button
                                  aria-label="Close"
                                  className="close"
                                  data-dismiss="modal"
                                  type="button"
                                  onClick={() => setModalAgregarEgreso(false)}
                                >
                                  <span aria-hidden={true}>×</span>
                                </button>
                                </div>
                                <div className="text-muted mt-2 mb-3">
                                <Form role="form">
                                <FormGroup className="mb-3 " >Importe:
                                        <Input
                                          placeholder="Importe..."
                                          type="number"
                                          value={Importe} 
                                          onChange={cambiarImporte}
                                        />
                                  </FormGroup>
                                  <FormGroup > Numero de Operación:
                                          <Input 
                                          placeholder="Numero de Operacion..." 
                                          type="text"
                                          value={Operacion} 
                                          onChange={cambiarOperacion} />
                                  </FormGroup>
                                  <FormGroup > Comentario:
                                    <Input 
                                    placeholder="Comentario..." 
                                    className=" form-control-alternative textarea-autosize"
                                    type="textarea"
                                    value={Comentario} onChange={cambiarComentario}
                                    />
                                </FormGroup>
                                <SubirComprobante setComprobanteId={setComprobanteId} />
                                <FormGroup >
                                    <label htmlFor="exampleFormControlSelect1" >Tipo de Egreso:</label>
                                    
                                        <SelectorGenerico Valor={Egreso} setValor={setEgreso} arrayElementos={TiposEgresos}/>
                                       
                                  </FormGroup>
                                  <div className="text-center">
                                    <Button
                                      className="my-4"
                                      color="primary"
                                      type="button"
                                      onClick={()=>AgregarEgreso()}
                                    >
                                      Agregar
                                    </Button>
                                
                                    <Button
                                      color="secondary"
                                      data-dismiss="modal"
                                      type="button"
                                      onClick={() => { setModalAgregarEgreso(false)}}
                                    >
                                      Cerrar
                                    </Button>                    
                                  </div>
                                </Form>                     
                                </div>                    
                              </CardHeader>                  
                            </Card>
                          </div>
                          </Modal>
        </>
    )
}
export default ModalAggEgreso


